import { EVENTS } from '../../../../../../../library';

export const TRANSLATION_PATH = (route) => {
  return `components.application.rewards.redeem.viewReward.overview.${route}`;
};

export const LOG_EVENT_PATH = (event) => {
  return EVENTS.COMPONENTS.APPLICATION.REWARDS.REDEEM.VIEW_REWARD.REWARD_OVERVIEW[event];
};
